import banner from "../img/breikki_banner.jpeg"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import { useTranslation } from "react-i18next"
import "../styles/AboutUs.css"
import { CLUB_INSTAGRAM_LINK_HREF } from "../constants"


const AboutUs = () => {
    const { t } = useTranslation()
    return (
      <Container>
        <Row>
          <Col className="BREIKKI-about-us-section-container" style={{maxWidth: "250px"}}>
            <Card className="About-us-acrostic-container">
              <Card.Body>
                <Card.Text>
                  <span className="BREIKKI-about-us-acrostic"><b>B</b>iljardia</span>
                  <span className="BREIKKI-about-us-acrostic"><b>R</b>akastavat</span>
                  <span className="BREIKKI-about-us-acrostic"><b>E</b>rityisen</span>
                  <span className="BREIKKI-about-us-acrostic"><b>I</b>nnokkaasti</span>
                  <span className="BREIKKI-about-us-acrostic"><b>K</b>eppiä</span>
                  <span className="BREIKKI-about-us-acrostic"><b>K</b>äyttävät</span>
                  <span className="BREIKKI-about-us-acrostic"><b>I</b>hmiset</span>
              </Card.Text>
             </Card.Body>
            </Card>
          </Col>
          <Col className="BREIKKI-about-us-section-container" >
            <Card className="About-us-card">
                <Card.Body>
                  <Card.Title>
                    <span className="BREIKKI-about-us-title">{t("about_us_title")}</span>
                  </Card.Title>
                  <Card.Text>
                    <p className="About-us-text">
                      {t("about_us_paragraph_1")} 
                    </p>

                    <p className="About-us-text">
                      {t("about_us_paragraph_2")} 
                    </p>

                    <p className="About-us-text">
                      {t("about_us_paragraph_3")} 
                    </p>

                    <p className="About-us-text">
                      {t("about_us_paragraph_4")} 
                    </p>

                    <p className="About-us-text">
                      {t("about_us_paragraph_5")} 
                    </p>
                 
                  </Card.Text>
                </Card.Body>
            </Card>
          </Col>
         
        </Row>

        <Row className="About-us-join-button-container">
            <a className="BREIKKI-about-us-join-link" target="blank" href="https://forms.office.com/e/QdjewcUUtC">{t("about_us_join_text")}</a>
            <a className="BREIKKI-about-us-join-link" target="blank" href={CLUB_INSTAGRAM_LINK_HREF}>{t("about_us_instagram_text")}</a>
            <a className="BREIKKI-about-us-join-link" target="blank" href="https://t.me/+QH-pYV8yc1xiY2U8">{t("about_us_join_telegram_text")}</a>
        </Row>
        
        <Container className="About-us-banner-container">
          <Row>
            <img alt="picture from a BREIKKI event"
                src={banner}
                width="100%"
                height="35%"
            />
          </Row>
        </Container>
      </Container>
        
    )
}

export default AboutUs